import { render, staticRenderFns } from "./CodeMessage.vue?vue&type=template&id=3e64e01e&scoped=true"
import script from "./CodeMessage.vue?vue&type=script&lang=js"
export * from "./CodeMessage.vue?vue&type=script&lang=js"
import style0 from "./CodeMessage.vue?vue&type=style&index=0&id=3e64e01e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e64e01e",
  null
  
)

export default component.exports